//---- components ---------
//---- mixins -------------
//---- services -----------
import { ajaxService } from '@/app/services';
import DraftService from "@/app/services/draft.service.js";
import ProjectHomeService from "@/app/services/projectHome.service.js";
import NotificationService from "@/app/services/notification.js";
//---- other --------------
import routes from '../routes.js';
import URL from '../common/URL.js';
//---- 3rd-parties --------
import VueRouter from 'vue-router'
import { mapGetters } from "vuex";

const { isNavigationFailure, NavigationFailureType } = VueRouter;

export default {
    computed: {
        // returns true if the screen width is compatible with mobile layout
        smallDevice() {
            return this.$store.getters['mobileLayout'];
        },
        // returns true if the screen width is compatible with desktop layout
        largeDevice() {
            return this.$store.getters['desktopLayout']
        },
        // returns true if the screen width is compatible with mobile layout
        mobileLayout() {
            return this.$store.getters["mobileLayout"];
        },
        // returns true if the screen width is compatible with desktop layout
        desktopLayout() {
            return this.$store.getters['desktopLayout'];
        },
        headerVariant() {
          return this.isKMOffline ? "kmoffline" : "dark";
        },
        secondaryHeaderVariant() {
          return this.isKMOffline ? "kmoffline-secondary" : "secondary";
        },
        ...mapGetters({
          isKMOffline: "kmOffline/isKMOffline",
        }),
    }, // end computed

    methods: {
        // pushes a new route if we are not already on it.
        // @param newRoute can either be a string representing the path or
        //                 an object containing both path and hash.
        // @return true if we pushed a new route, false otherwise
        //
        //   examples: safeRouterPush('/project-home')
        //
        //             safeRouterPush( {
        //                  path: '/ds/details', 
        //                  hash: 'page=1&dashTab=SESSION&oDS=DSBBB0051&sDS=DSBBB0051'
        //             } )
        //
        //             safeRouterPush( {
        //                  hash: 'page=1&dashTab=SESSION&oDS=DSBBB0051&sDS=DSBBB0051'
        //             } )
        safeRouterPush(newRoute) {

            let to;
            if (typeof newRoute === 'string' || newRoute instanceof String) {
                to = { path: newRoute };
            }
            else {
                to = newRoute;
            }

            // const router = this.$router || VueRouter;

            const handleFailure = function(failure) {
                // navigation failures should be ignored, they are already treated by the navigation guards
                if (!isNavigationFailure(failure, NavigationFailureType.redirected)
                    && !isNavigationFailure(failure, NavigationFailureType.duplicated)
                    && !isNavigationFailure(failure, NavigationFailureType.cancelled)
                    && !isNavigationFailure(failure, NavigationFailureType.aborted)) {
                    console.log(failure);
                    throw failure;
                } 
            }

            const fromPath = routes.currentRoute.path;
            const fromHash = routes.currentRoute.hash;
            try {
                // console.trace(fromPath+fromHash+' --> '+to.path+'#'+to.hash)
                if (to.path && to.path != fromPath) {
                    // console.log("fromPath= "+fromPath+"  toPath: "+to.path+"#"+to.hash)
                    routes.push({ path: to.path, hash: to.hash, params: to.params }).catch((failure) => handleFailure(failure))
                    return true;
                }
                if (to.hash && '#' + to.hash !== fromHash) {
                    // console.log("fromHash= " + fromHash + "  toHash: #" + to.hash)
                    if (to.path)
                        routes.push({ path: to.path, hash: to.hash, params: to.params }).catch((failure) => handleFailure(failure))
                    else
                        routes.push({ hash: to.hash, params: to.params }).catch((failure) => handleFailure(failure))
                    return true;
                }
            }
            catch (failure) {
                handleFailure(failure);
            }
            return false;
        },

        // check if we are in authoring and there are unsaved modifications and
        // asks the user if he wants to preserve them.
        // return true if the action can be performed, false if it should be aborted
        async checkForUnsavedAuthoringModifications(stayOnAuthoring) {
            if (routes.currentRoute.path != '/solution-modify')
                return true;

            if ((this.$store.state?.authoring?.dirtyAttributes || []).length == 0)
                return true;

            const ok = await NotificationService.showConfirmation(this.$t("case_management_confirm_leaving"));
            if (ok) {
                // clear dirty attributes
                this.$store.dispatch("authoring/initializeDirtyAttributes");

                // delete the draft case
                await DraftService.deleteDraftCase({})
                this.$store.dispatch("draft/getDraftCases");

                if (stayOnAuthoring) {
                    // execute back action to update backend
                    const state = this.isMCM ? "massCaseManagement" : "caseManagement";
                    await ProjectHomeService.backActionNoUpdate(state);
                }
            }
            return ok;
        },

        async checkForOpenServiceSession(profile) {
            if (!this.$store.state.projectData?.callCenterData?.diagnosticSession?.ID) {
                return true;
            }

            // backend call to isDsDisabledForProfile.action...
            var response = await ajaxService.getWithParams(URL.isDsDisabledForProfile, { profile: profile.id });
            var isDsDisabledForProfile = response.data.isDsDisabledForProfile;
            if (!isDsDisabledForProfile) {
                return true;
            }

            const ok = await NotificationService.showConfirmation(this.$t("Switching the profile will exit the open diagnostic session automatically. Do you want to continue?"));
            if (ok) {
                //backend call to closeCurrentDiagonasticSession.action

                if (await ajaxService.get(URL.closeCurrentDiagnosticSessionUrl))
                    return true;

            }

            return ok;
        },

    }, // end methods
}